import { useCallback, useState } from 'react'
import { IGetExportData } from 'src/app/shared/components/common/new-table/table-setting.model'
import { IPayeeMatchParametersItem } from 'src/app/shared/models/payeeMatchParameters.model'
import { deletePayee, getListPayeeMatchParameters } from 'src/app/shared/services/PayeeMatchParameters'

export const usePayeeMatchParameter = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [listPayeeMatchParameters, setListPayeeMatchParameters] = useState<IPayeeMatchParametersItem[]>()
  const [totalRecords, setTotalRecords] = useState(0)
  const [isDeleting, setIsDeleting] = useState<boolean>(false)

  const getDataPayeeMatchParameter = async (params: IGetExportData) => {
    try {
      setIsLoading(true)
      const data = await getListPayeeMatchParameters(params)

      setListPayeeMatchParameters(data?.data?.items)

      setTotalRecords(data?.data?.total)
      return data?.data
    } catch (e) {
      console.log('ERROR: ', e)
    } finally {
      setIsLoading(false)
    }
  }

  const deletePayeeMatchParameters = useCallback(async (id: string) => {
    try {
      setIsDeleting(true)
      return await deletePayee(id)
    } catch (error: any) {
      return error
    } finally {
      setIsDeleting(false)
    }
  }, [])

  return {
    listPayeeMatchParameters,
    totalRecords,
    getDataPayeeMatchParameter,
    isLoading,
    setIsDeleting,
    isDeleting,
    deletePayeeMatchParameters,
  }
}
